import { render, staticRenderFns } from "./pledge.vue?vue&type=template&id=88566e12"
import script from "./pledge.vue?vue&type=script&lang=js"
export * from "./pledge.vue?vue&type=script&lang=js"
import style0 from "./pledge.vue?vue&type=style&index=0&id=88566e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports